import AdminConsultants from "./AdminConsultants";

export default AdminConsultants;